import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomService } from 'app/components/dom/dom.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExhibitorProfileService } from 'app/components/exhibitor-profile/exhibitor-profile.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalExhibitorPasswordRecoveryComponent } from 'app/components/modal-exhibitor-password-recovery/modal-exhibitor-password-recovery.component';
import { CatalogueUserService } from 'app/components/catalogueUser/catalogue-user.service';
import { CataloguePlansService } from 'app/components/catalogue-plans/catalogue-plans.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { ModalImportExhibitorComponent } from '../../components/modal-import-exhibitor/modal-import-exhibitor.component';
import { ModalSimpleComponent } from '../../components/modal-simple/modal-simple.component';



@Component({
  selector: 'app-exhibitor-backoffice-exhibitor-detail-admin',
  templateUrl: './exhibitor-backoffice-exhibitor-detail-admin.component.html',
  styleUrls: ['./exhibitor-backoffice-exhibitor-detail-admin.component.css']
})
export class ExhibitorBackofficeExhibitorDetailAdminComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  catalogueId: string|null = '';
  catalogueName: string|null = '';
  exhibitorId: string|null = '';

  buttonLink: string = '';

  profile: object = {};

  exhibitorData: object = {
    exhibitor: {},
    exhibitorId: null
  };

  exhibitorStatuses: Array<any> = [];
  cataloguePlans: Array<any> = [];
  importData: Array<any> = [];
  sapId: string = '';

  constructor(private domService: DomService, private activatedRoute: ActivatedRoute, private exhibitorProfileService: ExhibitorProfileService,
  public catalogueService: CatalogueService, private exhitorsService: ExhitorsService, private ngbModal: NgbModal, private catalogueUserService: CatalogueUserService,
  private router: Router, private cataloguePlansService: CataloguePlansService, private utilsService: UtilsService, protected modalService: NgbModal) {
    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
    this.catalogueName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.buttonLink = this.catalogueService.getProperty('id') + '/' + this.catalogueName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/exhibitor-detail-admin-edit'
  }

  getProfile(getProfileIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhibitorProfileService.getProfile(getProfileIn)
      .subscribe((data: object) => {
        this.getProfileOk(data);
      },
        error => {
          this.getProfileError(error);
        });

  }

  getProfileOk(data) {

    this.loader.count--;
    this.profile = data;

  }

  getProfileError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getStatuses() {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getStatuses()
      .subscribe((data: object) => {
        this.getStatusesOk(data);
      },
        error => {
          this.getStatusesError(error);
        });

  }

  getStatusesOk(data) {
    this.loader.count--;
    this.exhibitorStatuses = data._embedded.exhibitorStatus;
  }

  getStatusesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  openModalExhibitorPasswordRecovery(user) {
    let modalRef = this.ngbModal.open(ModalExhibitorPasswordRecoveryComponent);
  
    modalRef.result.then(option => {
      if (option === 'yes') {
  
        let getTokenForgotPasswordIn = {
          accountId: this.catalogueService.getProperty('accountId'),
          eventId: this.catalogueService.getProperty('id'),
          username: user.userName // <-- use the clicked user
        };
  
        this.getTokenForgotPassword(getTokenForgotPasswordIn);
      }
    });
  }
  

  getTokenForgotPassword(getTokenForgotPasswordIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueUserService.getTokenForgotPassword(getTokenForgotPasswordIn)
      .subscribe((data: object) => {
        this.getTokenForgotPasswordOk(data);
      },
        error => {
          this.getTokenForgotPasswordError(error);
        });

  }

  getTokenForgotPasswordOk(data) {

    this.loader.count--;

    /** Set data to model */

  }

  getTokenForgotPasswordError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  goTo(url) {
    this.router.navigate([url]);
  }

  getByEventName(getByEventNameIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.cataloguePlansService.getByEventName(getByEventNameIn)
      .subscribe((data: object) => {
        this.getByEventNameOk(data);
      },
        error => {
          this.getByEventNameError(error);
        });

  }

  getByEventNameOk(data) {
    this.loader.count--;
    this.cataloguePlans = data._embedded.cataloguePlans;
  }

  getByEventNameError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getCataloguePlanData(planId) {

    for (let i = 0; i < this.cataloguePlans.length; i++) {
      if (this.cataloguePlans[i].id === planId) {
        return this.utilsService._api(this.cataloguePlans[i].translations, 'name');
      }
    }

  }

  getStatusData(statusId) {

    for (let i = 0; i < this.exhibitorStatuses.length; i++) {
      if (this.exhibitorStatuses[i].id === statusId) {
        return this.utilsService._api(this.exhibitorStatuses[i].translations, 'translation');
      }
    }

  }

  getImportableExhibitor(getImportableExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getImportableExhibitor(getImportableExhibitorIn)
      .subscribe((data: object) => {
        this.getImportableExhibitorOk(data);
      },
        error => {
          this.getImportableExhibitorError(error);
        });

  }

  getImportableExhibitorOk(data) {

    this.loader.count--;
    this.importData = data;

  }

  getImportableExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  importExhibitor() {
    const modalRef = this.modalService.open(ModalImportExhibitorComponent, {size:'lg'});
    modalRef.componentInstance.exhibitorId = this.exhibitorId;
    modalRef.componentInstance.sapId = this.sapId;
    modalRef.componentInstance.importData = JSON.parse(JSON.stringify(this.importData));

    
    modalRef.result.then((result) => {
      if(result.id){
        this.exhitorsService.editCopyExhibitorAndProducts(Number(this.exhibitorId), result).subscribe(res => {
              const modalRef = this.modalService.open(ModalSimpleComponent);
              modalRef.componentInstance.titleTranslation = 'MODAL_SIMPLE.TITLE_INFORMATION';
              modalRef.componentInstance.modalInformation = 'MODAL_SIMPLE.COPY_MSG';
              modalRef.componentInstance.isHtml = false;
        });
      }
    }, (reason) => {
      //console.log('Modal dismissed with:', reason);
    });
  }

  
  getExhibitor(getExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getExhibitor(getExhibitorIn)
      .subscribe((data: object) => {
        this.getExhibitorOk(data);
      },
        error => {
          this.getExhibitorError(error);
        });

  }

  getExhibitorOk(data) {

    this.loader.count--;
    this.sapId = data.sapId;

    let getImportableExhibitorIn = {
      exhibitorId: this.exhibitorId,
      sapId: this.sapId
    }

    this.getImportableExhibitor(getImportableExhibitorIn);

  }

  getExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  ngOnInit() {
    this.domService.addClassToBody('bg-gray');
    this.exhibitorData['exhibitorId'] = this.exhibitorId;

    this.getStatuses();

    let getProfileIn = {
      catalogueId: this.catalogueService.getProperty('id'),
      exhibitorId: this.exhibitorId
    }

    this.getProfile(getProfileIn);

    let getByEventNameIn = {
      eventName: this.catalogueName
    }

    this.getByEventName(getByEventNameIn);

    let getExhibitorIn = {
      exhibitorId: this.exhibitorId
    }

    this.getExhibitor(getExhibitorIn);

  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
